/*
 * Apptypes
 * Each action has a corresponding type, which the reducer knows and picks up on.
 * To avoid weird typos between the reducer and the actions, we save them as
 * types here. We prefix them with 'yourproject/YourComponent' so we avoid
 * reducers accidentally picking up actions they shouldn't.
 *
 * Follow this format:
 * export const YOUR_ACTION_CONSTANT = 'yourproject/YourContainer/YOUR_ACTION_CONSTANT';
 */

const scope = process.env.REACT_APP_BASENAME;

// Auth

export const CUSTOMER_USER_LOGIN = `${scope}/CUSTOMER_USER_LOGIN`;
export const USER_LOGIN = `${scope}/USER_LOGIN`;
export const USER_LOGIN_ERROR = `${scope}/USER_LOGIN_ERROR`;
export const USER_LOGIN_SUCCESS = `${scope}/USER_LOGIN_SUCCESS`;

export const USER_CHECK = `${scope}/USER_CHECK`;

export const USER_LOAD = `${scope}/USER_LOAD`;
export const USER_LOAD_SUCCESS = `${scope}/USER_LOAD_SUCCESS`;
export const USER_LOAD_FAILURE = `${scope}/USER_LOAD_FAILURE`;
export const USER_LOAD_CANCELLED = `${scope}/USER_LOAD_CANCELLED`;

export const USER_LOGOUT = `${scope}/USER_LOGOUT`;
export const USER_LOGOUT_SUCCESS = `${scope}/USER_LOGOUT_SUCCESS`;
export const USER_LOGOUT_FAILURE = `${scope}/USER_LOGOUT_FAILURE`;

export const USER_RESET_PASSWORD = `${scope}/USER_RESET_PASSWORD`;
export const USER_RESET_PASSWORD_SUCCESS = `${scope}/USER_RESET_PASSWORD_SUCCESS`;
export const USER_RESET_PASSWORD_ERROR = `${scope}/USER_RESET_PASSWORD_ERROR`;

export const USER_VERIFICATION = `${scope}/USER_VERIFICATION`;
export const USER_VERIFICATION_SUCCESS = `${scope}/USER_VERIFICATION_SUCCESS`;
export const USER_VERIFICATION_ERROR = `${scope}/USER_VERIFICATION_ERROR`;

export type AuthState = {
  token: any;
  pending: boolean;
  error: any;
  user: any;
  settings: any;
  response_code: string;
  message: string;
};
